:host {
  @media print {
    display: none;
  }
}

.stzh-youtube {
}
